import React, { useCallback, useContext, useEffect, useState } from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';
import { AngularServicesContext } from 'react-app';
import { useSelector } from 'react-redux';

// Redux
import { RootState } from 'redux/schemas';
import { useAppDispatch } from 'redux/store';
import { getLecturePage } from 'redux/selectors/timeline';
import { openConfirmationDialog, closeConfirmationDialog } from 'redux/actions/confirmation-dialogs';

// Components
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import LinkedCourseModal from 'content-library/components/collection-home/linked-course-modal';
import ClickableContainer from 'components/clickable-container';


const ConfirmationBodyContent = ({ handleLinkedLesson }) => (
  <div>
    <div>
      <span>{t.LECTURE_PAGES.COMPONENTS.SUBMISSIONS_DISCOVERY.UPDATE_ASSIGNMENT_CONFIRMATION.DESCRIPTION()}</span>
      <ClickableContainer
        className='d-inline'
        onClick={handleLinkedLesson}
      >
        {t.LECTURE_PAGES.COMPONENTS.SUBMISSIONS_DISCOVERY.UPDATE_ASSIGNMENT_CONFIRMATION.LINKED_LESSON()}
      </ClickableContainer>
    </div>
    <br />
    <div>
      {t.LECTURE_PAGES.COMPONENTS.SUBMISSIONS_DISCOVERY.UPDATE_ASSIGNMENT_CONFIRMATION.DESCRIPTION2()}
    </div>
  </div>
);

const ShowLinkedLessonWrapper = () => {
  const dispatch = useAppDispatch();
  const angularServices = useContext(AngularServicesContext);
  const $scope = angularServices?.$scope;
  const [showLinkedCoursesModel, setShowLinkedCoursesModel] = useState(false);
  const [shouldShowConfirmationDialog, setShouldShowConfirmationDialog] = useState(true);
  const { mode, catalogId, lecturePageId } = useLecturePageParams();
  const lecturePage = useSelector((state: RootState) => getLecturePage(state, lecturePageId));


  const openLinkedLessonModal = useCallback(() => {
    setShowLinkedCoursesModel(true);
    dispatch(closeConfirmationDialog());
  }, [dispatch]);

  const closeLinkedLessonModal = () => {
    setShowLinkedCoursesModel(false);
    setShouldShowConfirmationDialog(true); // Re-open confirmation dialog
  };


  const openConfirmation = useCallback(() => {
    dispatch(
      openConfirmationDialog({
        title: t.LECTURE_PAGES.COMPONENTS.SUBMISSIONS_DISCOVERY.UPDATE_ASSIGNMENT_CONFIRMATION.ARE_YOU_SURE(),
        bodyText: <ConfirmationBodyContent handleLinkedLesson={openLinkedLessonModal} />,
        cancelText: t.FORM.CANCEL(),
        confirmText: t.FORM.YES_SURE(),
        onConfirm: () => $scope.vm.save(),
        onCancel: () => $scope.vm.cancelUpdateAssignmentConfirmationModal(),
      }),
    );
  }, [dispatch, $scope, openLinkedLessonModal]);

  useEffect(() => {
    if (shouldShowConfirmationDialog) {
      openConfirmation();
      setShouldShowConfirmationDialog(false);
    }
  }, [shouldShowConfirmationDialog, openConfirmation]);


  return (
    <div>
      <LinkedCourseModal
        lessonId={lecturePage?.id}
        showLinkedCourseModel={showLinkedCoursesModel}
        closeLinkedCourseModel={closeLinkedLessonModal}
      />
    </div>
  );
};

export default ShowLinkedLessonWrapper;

